import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { MetaFilterTotal } from '../filter';
import { MetaTotal } from '../meta-total';

@Injectable({
    providedIn: 'root'
})
export class MetaTotalHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/meta`;
    }

    /** Obtem os totais das metas da empresa e dos representantes */
    getTotais(idMeta: number, filter: MetaFilterTotal): Observable<MetaTotal> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.customHttp.get<MetaTotal>(`${this.pathApi}/${idMeta}/totais`, {params});
    }
}
